import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/20/solid';

const PasswordStrengthIndicator = ({ password = '', requirements = [] }) => {
  if (!requirements.length) return null;

  return (
    <div className="mt-3 space-y-1.5">
      {requirements.map((req) => {
        const isValid = req.regex.test(password);
        return (
          <div key={req.text} className={`flex items-center text-xs ${isValid ? 'text-green-600' : 'text-gray-500'}`}>
            {isValid ? (
              <CheckCircleIcon className="h-4 w-4 mr-1.5 flex-shrink-0" />
            ) : (
              <XCircleIcon className="h-4 w-4 mr-1.5 flex-shrink-0 text-gray-400" />
            )}
            <span>{req.text}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PasswordStrengthIndicator;

// Example usage (can be defined in the RegisterPage component or a config file)
export const defaultPasswordRequirements = [
  { text: "Minimum 8 characters", regex: /.{8,}/ },
  { text: "Include an uppercase letter", regex: /[A-Z]/ },
  { text: "Include a lowercase letter", regex: /[a-z]/ },
  { text: "Include a number", regex: /[0-9]/ },
  { text: "Include a symbol (e.g., !@#$%)", regex: /[^A-Za-z0-9]/ },
];
